export const extractFileFromData = (data: unknown): File | undefined => {
  if (
    data &&
    typeof data === "object" &&
    "attachments" in data &&
    Array.isArray((data as { attachments?: unknown }).attachments)
  ) {
    return (data as { attachments: File[] }).attachments[0];
  }
  return undefined;
};

export const readFileAsDataURL = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const dataUrl = e.target?.result as string;
      if (dataUrl) {
        resolve(dataUrl);
      } else {
        reject(new Error("Failed to read file as data URL"));
      }
    };
    reader.onerror = () => reject(new Error("FileReader error"));
    reader.readAsDataURL(file);
  });
};
